/**
 * 应用图标系统 — 统一常量
 * AppsView、AppModal、AppPublishModal 均使用此文件
 * 
 * 所有图标使用 20×20 viewBox，stroke-based
 */

// 图标路径（20×20 坐标系）
export const APP_ICON_PATHS: Record<string, string> = {
  // 数据分析
  chart:       'M4 17V9m6 8V3m6 14V6',
  activity:    'M1 10h5l2-7 4 14 2-7h5',
  pie:         'M10 2a8 8 0 1 0 8 8h-8V2Z',
  bar:         'M3 17V9h3v8m4-8v8m0-8V5h3v12m4 0V9h3v8',
  trending:    'M2 16l5-5 4 4 5-6 4-2',
  // 工具
  apps:        'm10 2 8 4v9l-8 4-8-4V6l8-4Zm0 8v9M2 6l8 4 8-4',
  briefcase:   'M5 7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2M2 7h16v11H2V7Zm5 0V5m6 2V5',
  target:      'M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-4 7-7m-1-2v3h3',
  // 沟通
  headphones:  'M3 10V9a7 7 0 0 1 14 0v1M3 9H2v6h4V9H3Zm14 0h1v6h-4V9h3Zm0 6v2h-5',
  megaphone:   'm2 7 8-2 7-3v16l-7-3-8-2V7Zm8-2v10m-5-1 2 4h3l-2-3',
  mail:        'M2 5h16v12H2V5Zm0 0 8 7 8-7',
  phone:       'M16 3h3v3.5a14 14 0 0 1-14 14H2v-3l2-1.5A11 11 0 0 0 14.5 5L16 3Z',
  // 内容
  file:        'M12 2H5v16h10V5l-3-3Zm0 0v4h3M8 10h4m-4 3h4',
  folder:      'M2 5V3h6l2 2h8v12H2V5Z',
  book:        'M10 4C7 2 4 2 2 3v14c3-1 5-1 8 1 3-2 5-2 8-1V3c-2-1-5-1-8 1Zm0 0v14',
  edit:        'm13 2 5 5-11 11H2v-5L13 2Zm-3 3 5 5',
  clipboard:   'M7 3h6v3H7V3ZM5 3H3v14h14V3h-2m-7 6h6m-6 3h6m-6 3h4',
  // 技术
  code:        'M7 8l-4 4 4 4M13 8l4 4-4 4',
  database:    'M18 5c0 1.66-3.58 3-8 3S2 6.66 2 5m16 0C18 3.34 14.42 2 10 2S2 3.34 2 5m16 0v5c0 1.66-3.58 3-8 3S2 11.66 2 10V5m16 10v-5',
  cloud:       'M17 15a5 5 0 0 0 0-10 5.002 5.002 0 0 0-9.8 1.2A4 4 0 1 0 6 15h11Z',
  // 人员
  users:       'M7 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5 8v-2c0-5 10-5 10 0v2H2Zm11-14a3 3 0 0 1 0 6m2 3c3 0 3 3 3 5h-3',
  user:        'M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8v-2c0-6 14-6 14 0v2H3Z',
  building:    'M2 18h16M4 18V5l6-3 6 3v13M8 18v-5h4v5M7 7h.01M13 7h.01M7 10h.01M13 10h.01',
  // AI / 智能
  sparkles:    'm10 2 1.5 4.5a1.5 1.5 0 0 0 2 2L18 10l-4.5 1.5a1.5 1.5 0 0 0-2 2L10 18l-1.5-4.5a1.5 1.5 0 0 0-2-2L2 10l4.5-1.5a1.5 1.5 0 0 0 2-2L10 2Z',
  zap:         'M11 2 4 12h6l-1 6 7-10h-6l1-6Z',
  star:        'M10 2l2.4 5 5.6.8-4 3.9.9 5.5-5-2.6-5 2.6.9-5.5-4-3.9 5.6-.8L10 2Z',
  cpu:         'M7 7h6v6H7V7ZM5 2v3M10 2v3m5-3v3M2 5h3m0 5H2m3 5H2M5 18v-3m5 3v-3m5 3v-3m3-8h-3m3 5h-3M18 5h-3',
  // 地图/全局
  globus:      'M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-16c-5 3-5 13 0 16 5-3 5-13 0-16ZM2 10h16',
  globe:       'M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-16c-5 3-5 13 0 16 5-3 5-13 0-16ZM2 10h16',
  // 财务
  calculator:  'M5 3h10v14H5V3Zm3 4h4m-4 3h4m-4 3h1m3 0h1M8 4h1',
  // 仓储
  archive:     'M2 5h16v3H2V5Zm1 3h14v9H3V8Zm4 4h6',
  // 系统工具
  tools:       'M3 3h5v5H3V3Zm9 0h5v5h-5V3ZM3 12h5v5H3v-5Zm9 0h5v5h-5v-5Z',
  monitor:     'M2 3h16v11H2V3Zm8 11v4m-4 0h8',
  shield:      'm10 2 7 3v5c0 4-7 8-7 8S3 14 3 10V5l7-3Zm-3 8 2 2 4-5',
  link:        'm7 13 6-6m-5 8-1 1a4 4 0 0 1-6-6l4-4a4 4 0 0 1 5-1m0 0 2-2a4 4 0 0 1 6 6l-4 4a4 4 0 0 1-5 1',
  settings:    'M7 2h6l1 3 3 1 1 5-2 2v3l-5 2-3-1-3 1-3-4 1-3-1-3 3-3 2-3Zm3 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6',
  chat:        'M2 3h16v11H7l-5 4V3Zm4 4h8m-8 3h5',
  lightbulb:   'M7 15h6m-5 3h4M6 11a6 6 0 1 1 8 0c-1 1-1 2-1 2H7s0-1-1-2',
  search:      'M9 15A6 6 0 1 0 9 3a6 6 0 0 0 0 12Zm4.5-1.5L18 18',
};

// 配色方案（对应原型的 tone）
export const APP_ICON_TONES: Record<string, { gradient: string; color: string; label: string }> = {
  blue:  { gradient: 'linear-gradient(155deg, #4998ff, #1264e4)', color: '#fff',    label: '蓝色' },
  ink:   { gradient: 'linear-gradient(155deg, #41444e, #202229)', color: '#fff',    label: '深色' },
  sage:  { gradient: 'linear-gradient(155deg, #a3c7b3, #709e87)', color: '#fff',    label: '绿色' },
  sand:  { gradient: 'linear-gradient(155deg, #fbf9f4, #eae3d3)', color: '#30343b', label: '米色' },
  plum:  { gradient: 'linear-gradient(155deg, #b6a4c0, #887295)', color: '#fff',    label: '紫色' },
  paper: { gradient: 'linear-gradient(155deg, #fafafb, #e8eaee)', color: '#30343b', label: '浅色' },
};

// 分类对应的默认配色和图标
export const CAT_DEFAULT_TONE: Record<string, string> = {
  sales:     'blue',
  ops:       'ink',
  service:   'sage',
  marketing: 'plum',
  design:    'plum',
  inventory: 'sand',
  finance:   'sage',
};

export const CAT_DEFAULT_ICON: Record<string, string> = {
  sales:     'chart',
  ops:       'apps',
  service:   'headphones',
  marketing: 'megaphone',
  design:    'edit',
  inventory: 'archive',
  finance:   'calculator',
};

// 图标选择器的分组展示
export const ICON_PICKER_GROUPS: Array<{ label: string; icons: string[] }> = [
  { label: '文档知识', icons: ['file', 'folder', 'book', 'edit', 'chat', 'calculator'] },
  { label: '数据分析', icons: ['chart', 'activity', 'file', 'database', 'search', 'globe'] },
  { label: '销售经营', icons: ['chart', 'users', 'target', 'activity', 'building', 'link'] },
  { label: '市场内容', icons: ['edit', 'lightbulb', 'megaphone', 'phone', 'mail', 'sparkles'] },
  { label: '团队协作', icons: ['user', 'users', 'chat', 'clipboard', 'calculator', 'building'] },
  { label: '技术开发', icons: ['code', 'link', 'tools', 'monitor', 'settings', 'shield'] },
];

// 配色选项
export const TONE_OPTIONS = Object.entries(APP_ICON_TONES).map(([id, { label }]) => ({ id, label }));

// 解析 icon_choice（支持对象和 JSON 字符串）
export function parseIconChoice(raw: unknown): { icon: string; tone: string } {
  const DEFAULT = { icon: 'sparkles', tone: 'blue' };
  if (!raw) return DEFAULT;
  if (typeof raw === 'object' && raw !== null) {
    const r = raw as Record<string, unknown>;
    return {
      icon: typeof r.icon === 'string' ? r.icon : DEFAULT.icon,
      tone: typeof r.tone === 'string' ? r.tone : DEFAULT.tone,
    };
  }
  if (typeof raw === 'string') {
    try {
      return parseIconChoice(JSON.parse(raw));
    } catch {
      return DEFAULT;
    }
  }
  return DEFAULT;
}

// 根据应用分类和 icon_choice 计算最终渲染参数
export function resolveAppIcon(cat: string, iconChoice: unknown): {
  gradient: string;
  color: string;
  svgPath: string;
} {
  const choice = parseIconChoice(iconChoice);
  const tone = APP_ICON_TONES[choice.tone] || APP_ICON_TONES[CAT_DEFAULT_TONE[cat]] || APP_ICON_TONES.paper;
  const path = APP_ICON_PATHS[choice.icon] || APP_ICON_PATHS[CAT_DEFAULT_ICON[cat]] || APP_ICON_PATHS.apps;
  return {
    gradient: tone.gradient,
    color: tone.color,
    svgPath: path,
  };
}
